import { apiCall, createQueryString } from "../imports"

const PREFIX = "shop/vehicle-types"

export default {

    get(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`)
    },

    create(data) {
        return apiCall('post', `${PREFIX}`, data)
    },

    update(vehicleTypeID, data) {
        return apiCall('post', `${PREFIX}/${vehicleTypeID}/update`, data)
    },

    delete(vehicleTypeID) {
        return apiCall('delete', `${PREFIX}/${vehicleTypeID}`)
    }
}